export const KickTestIds = {
  buttonCancelKickmember: 'button_cancel_kickMember',
  buttonConfirmKickmember: 'button_confirm_kickMember',
  dialogKickmember: 'dialog_kickMember',
  dialogKickmemberContent: 'dialog_kickMember_content',
  buttonCancelBulkKick: 'button_cancel_bulk_kick',
  buttonConfirmBulkKick: 'button_confirm_bulk_kick',
  dialogBulkKick: 'dialog_bulk_kick',
  dialogBulkKickContent: 'dialog_bulk_kick_content'
} as const;
